export default "__VITE_ASSET__d7493dd0__"